export const APP_FILE_CSIO_EDI_LIST = "/csio-edi-list";
export const APP_FILE_MANAGE_CSIO_EDI = "/csio-edi-list/manage";